import { Card } from "@/components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const FAQS = [
  { q: "DoctoSpa remplace-t-il un technicien professionnel ?", a: "Non. DoctoSpa est un outil d'aide au diagnostic. Il vous permet d'identifier les causes probables d'une panne et de réaliser les gestes courants. Pour toute intervention électrique ou changement de composant sous garantie, faites appel à un professionnel." },
  { q: "Le diagnostic est-il vraiment gratuit ?", a: "Oui, le questionnaire et le score global sont 100% gratuits, sans carte bancaire. Seul le rapport détaillé (causes probables + actions correctives) est payant." },
  { q: "Quels types de spas sont pris en charge ?", a: "Tous les spas et jacuzzis domestiques (marques principales : Aquavia, Caldera, Jacuzzi, Sundance, Wellis, Intex, Bestway, etc.). Nous ne couvrons pas les spas commerciaux à haut volume." },
  { q: "Comment fonctionne l'abonnement Premium ?", a: "Pour 14,99€/mois, vous accédez à tous vos rapports détaillés sans limite. Résiliable à tout moment via votre espace client Stripe." },
  { q: "Mes données sont-elles conservées ?", a: "Vos diagnostics et données de compte sont stockés de manière sécurisée. Aucune donnée n'est vendue à des tiers. Conformité RGPD." },
  { q: "Puis-je obtenir un remboursement ?", a: "Pour un rapport à l'unité, le remboursement est possible sous 14 jours si le rapport n'a pas été consulté. Pour l'abonnement, la résiliation est immédiate mais sans remboursement du mois entamé." },
  { q: "Le paiement est-il sécurisé ?", a: "Oui, tous les paiements passent par Stripe, standard mondial de sécurité (PCI-DSS Level 1). Nous ne stockons aucune donnée bancaire." },
];

export default function FAQ() {
  return (
    <div className="mx-auto max-w-3xl px-6 lg:px-10 py-16 lg:py-20" data-testid="faq-page">
      <div className="text-center">
        <div className="eyebrow">Questions fréquentes</div>
        <h1 className="mt-3 font-display text-4xl lg:text-5xl font-black tracking-tighter">Tout ce qu'il faut savoir</h1>
        <p className="mt-4 text-muted-foreground">Une question qui n'est pas dans la liste ? Contactez-nous.</p>
      </div>

      <Card className="mt-12 p-2 sm:p-4 border-black/10">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="px-4 border-b border-black/5 last:border-0" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-display text-left font-semibold text-base hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Card>

      <div className="mt-14 rounded-2xl bg-secondary text-white p-8 text-center">
        <h3 className="font-display text-2xl font-bold">Toujours une question en tête ?</h3>
        <p className="mt-2 text-sm text-white/70">Notre équipe répond en moins de 24h.</p>
        <Link to="/contact"><Button className="mt-6 bg-white text-secondary hover:bg-white/90 rounded-full h-11 px-6">Nous contacter</Button></Link>
      </div>
    </div>
  );
}
